import { render, staticRenderFns } from "./CategoryRecommendations.vue?vue&type=template&id=be1bb316&scoped=true"
import script from "./CategoryRecommendations.vue?vue&type=script&lang=js"
export * from "./CategoryRecommendations.vue?vue&type=script&lang=js"
import style0 from "./CategoryRecommendations.vue?vue&type=style&index=0&id=be1bb316&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be1bb316",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F02-molecules%2Fcategory-recommendations%2FCategoryRecommendations.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports